// src/pages/Legal/PrivacyPolicy.jsx
import React from "react";
import "./PrivacyPolicy.css"

const PrivacyPolicy = () => {
  return (
    <div className="legal-page-container">
      <h1>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> January 7, 2026
      </p>

      <p>
        At <strong>BA Code Solution</strong>, we respect your privacy and are
        committed to protecting the personal and business information you share
        with us. This Privacy Policy explains how we collect, use, and safeguard
        your information when you interact with our website, services, and
        applications.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          Personal details such as name, email address, phone number, and
          company name
        </li>
        <li>
          Business-related information provided through contact forms or project
          discussions
        </li>
        <li>
          Technical data including IP address, browser type, device information,
          and usage data
        </li>
        <li>
          Any information you voluntarily share while communicating with us
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Respond to inquiries and provide requested services</li>
        <li>Understand your business needs and propose suitable solutions</li>
        <li>Improve our website, services, and user experience</li>
        <li>
          Communicate important updates, service-related information, or support
          responses
        </li>
        <li>Maintain security and prevent unauthorized access</li>
      </ul>

      <h2>3. Data Protection & Security</h2>
      <p>
        We implement appropriate technical and organizational measures to
        protect your data against unauthorized access, loss, or misuse. While we
        take strong precautions, no digital system is completely secure.
      </p>

      <h2>4. Data Sharing</h2>
      <p>
        BA Code Solution does <strong>not sell, rent, or trade</strong> your
        personal information. Data may be shared only to comply with legal
        obligations, protect rights, or with trusted service providers under
        confidentiality agreements.
      </p>

      <h2>5. Cookies & Tracking</h2>
      <p>
        Our website may use cookies and similar technologies to enhance user
        experience, analyze traffic, and improve performance. You can disable
        cookies via your browser settings.
      </p>

      <h2>6. Third-Party Links</h2>
      <p>
        Our website may contain links to third-party platforms. We are not
        responsible for their privacy practices or content.
      </p>

      <h2>7. Policy Updates</h2>
      <p>
        This Privacy Policy may be updated from time to time. Any changes will
        be reflected on this page with an updated effective date.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have questions regarding this Privacy Policy, please contact us
        through our <strong>Contact Us</strong> page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
